import {FC} from 'react'
import {Table} from 'react-bootstrap'

const BasicTable: FC<BasicTableProps> = (props) => {
  return (
    <div style={{marginLeft: '6%'}}>
      <Table className='basic-table' responsive striped bordered hover size='sm'>
        <thead>
          <tr>
            {props.colum?.map((item: any, key: number) => {
              return <th key={key}>{item.value}</th>
            })}
          </tr>
        </thead>
        <tbody>
          {props.rows?.map((item: any, key: number) => {
            return (
              <tr key={key}>
                {props.colum?.map((colum: any, key2: number) => {
                  return <td key={key2}>{item[colum.key]}</td>
                })}
              </tr>
            )
          })}
        </tbody>
      </Table>
    </div>
  )
}
BasicTable.defaultProps = {
  edit: false,
}
interface BasicTableProps {
  colum?: any
  rows?: any
  edit?: boolean
}
export {BasicTable}
